
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class TrainMovesBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class TrainMovesBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u: string = data._id.match(/^mv-trains-(.*)/i)[1];
    const dir:    string = data.dd;

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Moving Trains ${data.l.n} ${dir}...`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'moving-trains',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      direction:       data.dd,
      kind:            data.l.k,
      sIndex:          data.l.sx,
      index:           data.l.ix,
      u:               data._id
    };

  }
}
